import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import { handleScrollToTop } from '../../helpers/jsHelper';
import { resetFilters } from '../../redux/slicers/admin/sidebarSlicer';
import styles from './customTab.module.scss';
import { useDispatch } from 'react-redux';
import { Mixpanel } from '../Mixpanel';
import Loader from '../Loader';

const settingTabList = [
  {
    eventKey: 'tab1',
    title: 'tab1',
    component: <div>tab1</div>,
  },
  {
    eventKey: 'tab2',
    title: 'tab2',
    component: <div>tab2</div>,
  },
  {
    eventKey: 'tab3',
    title: 'tab3',
    component: <div>tab3</div>,
  },
];

export default function CustomTab({
  loading = false,
  tabList = settingTabList,
  defaultActive = null,
  className = '',
  sticky = true,
  handleActiveTab = null,
  stopScroll = false,
  linkName = '',
  linkAction = null,
  style = {},
  tabContainerClassName = '',
  hideStickyHeader = false,
  loadAllTabs = false,
  stopReset = false,
  unmountOnExit = true, // Default: unmount inactive tabs. Set to false to keep all tabs mounted (hidden)
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(defaultActive);
  const placeholderRef = useRef(null);
  const [manageHidden, setManageHidden] = useState('hidden');
  const location = useLocation();
  const [headerClass, setHeaderClass] = useState('');
  let scrollPos = 0;

  useEffect(() => {
    if (!stopScroll) {
      handleScrollToTop();
    }
  }, []);

  useEffect(() => {
    handleActiveTab?.(activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (placeholderRef?.current && document.body.getBoundingClientRect().top === 0) {
      setManageHidden('hidden');
      setHeaderClass('hidden');
    }
  }, [location.pathname, placeholderRef]);

  useEffect(() => {
    setActiveTab(defaultActive);
  }, [defaultActive]);

  const handleTabChange = (key, route, mxEvent = null, mxEventProps = {}) => {
    window.$restrictFilter = null;
    if (key !== activeTab) {
      !stopReset && dispatch(resetFilters());
      setActiveTab(key);
      if (mxEvent) Mixpanel.track(true, mxEvent, mxEventProps);
      if (route) navigate(route);
      if (!stopScroll) {
        handleScrollToTop(100);
      }
    }
  };

  const scrollHeaderFixed = () => {
    if (placeholderRef.current && placeholderRef.current.getBoundingClientRect().bottom > 0) {
      setHeaderClass('hidden');
      return;
    }

    const newScrollPos = document.body.getBoundingClientRect().top;
    if (newScrollPos > scrollPos) {
      setHeaderClass('sticky-active');
      setManageHidden('');
    } else {
      setHeaderClass('');
    }
    scrollPos = newScrollPos;
  };

  useEffect(() => {
    if (!sticky) return;

    window.addEventListener('scroll', scrollHeaderFixed);

    return () => window.removeEventListener('scroll', scrollHeaderFixed);
  }, []);

  return (
    <div className={`ps-4 pe-1 py-3 ${className}`} style={style}>
      {loading ? <Loader loading={true} position="absolute" size={30} thickness={3} /> : null}
      <Tab.Container defaultActiveKey={activeTab} activeKey={activeTab}>
        <div
          className={`${styles.commonTabContainer} ${tabContainerClassName}`}
          ref={placeholderRef}>
          <Nav as="ul" className={styles.commonTab}>
            {tabList?.map((list) => {
              return (
                <Nav.Item
                  key={list?.eventKey}
                  as="li"
                  style={list?.tabStyle || {}}
                  onClick={() =>
                    handleTabChange(
                      list?.eventKey,
                      list?.route,
                      list?.mx_event,
                      list?.mx_event_props
                    )
                  }>
                  <Nav.Link eventKey={list?.eventKey}>{list?.title}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>
          {linkName ? (
            <div className={styles.linkName} onClick={linkAction}>
              <span>{linkName}</span>
            </div>
          ) : null}
        </div>
        {!hideStickyHeader ? (
          <div
            className={`${styles.commonTabContainer} sticky ${
              headerClass !== manageHidden ? manageHidden : ''
            } ${headerClass}`}>
            <Nav as="ul" className={`${styles.commonTab} `}>
              {tabList?.map((list) => {
                return (
                  <Nav.Item
                    key={list?.eventKey}
                    as="li"
                    style={list?.tabStyle || {}}
                    onClick={() =>
                      handleTabChange(
                        list?.eventKey,
                        list?.route,
                        list?.mx_event,
                        list?.mx_event_props
                      )
                    }>
                    <Nav.Link eventKey={list?.eventKey}>{list?.title}</Nav.Link>
                  </Nav.Item>
                );
              })}
            </Nav>
            {linkName ? (
              <div className={styles.linkName} onClick={linkAction}>
                <span>{linkName}</span>
              </div>
            ) : null}
          </div>
        ) : null}
        <Tab.Content>
          {tabList?.map((list) => {
            const isActive = activeTab === list?.eventKey;
            
            // If unmountOnExit is true (default), only render active tab (unless loadAllTabs)
            // If unmountOnExit is false, render all tabs but hide inactive ones
            if (unmountOnExit && !loadAllTabs && !isActive) {
              return null;
            }

            return (
              <Tab.Pane
                key={list?.eventKey}
                eventKey={list?.eventKey}
                className={list?.tabContentClassName || ""}
                style={{
                  ...(loadAllTabs ? { transition: 'none' } : {}),
                  ...(list?.tabContentStyle || {}),
                  // Hide inactive tabs when unmountOnExit is false
                  ...(!isActive && !unmountOnExit ? { display: 'none' } : {}),
                }}>
                {list?.component}
              </Tab.Pane>
            );
          })}
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
